// @flow
import React from 'react';
import Lottie from 'react-lottie';
import dateRangeGif from 'src/assets/json/merchandising/gif-date-range.json';
import { HomeMajor, ProductsMajor, CollectionsMajor, CheckoutMajor } from '@shopify/polaris-icons';

export * from './rule';

// Product tour config for rule page
export const defaultOptions = gif => ({
  loop: true,
  autoplay: true,
  animationData: gif
});
export const COLUMN_WIDGET = [
  { value: 'name', label: 'column3_Title', textAlign: 'left', width: 27, width2: 26 },
  { value: 'status', label: 'column1_Title', textAlign: 'left', width: 12, width2: 11 },
  { value: 'widgetId', label: 'column2_Title', textAlign: 'left', width: 27, width2: 24 },
  { value: 'type', label: 'column4_Title', textAlign: 'left', width: 24, width2: 23 },
  { value: 'actions', label: 'column6_Title', textAlign: 'center', width: 10, width2: 16 }
];

export const PERSONALIZED_RECOMMENDATION = 'personalized-recommendation';
export const CART_DRAWER = 'cart-drawer';

const CheckOutPlus = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className='Polaris-Icon__Svg'>
    <path
      d="M13 4C13 3.44772 13.4477 3 14 3H18C18.5523 3 19 3.44772 19 4C19 4.55228 18.5523 5 18 5H14C13.4477 5 13 4.55228 13 4Z"
    />
    <path
      d="M16 1C16.5523 1 17 1.44772 17 2L17 6C17 6.55228 16.5523 7 16 7C15.4477 7 15 6.55228 15 6L15 2C15 1.44772 15.4477 1 16 1Z"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.50879 0C4.34018 0 5.01465 0.671572 5.01465 1.5V2.06055C6.4799 2.16619 8.43664 2.30726 9.77233 2.40356C10.55 2.45962 11 3.22036 11 4V5C11 7.20914 12.7909 9 15 9H16C16.2545 9 16.5176 9 16.7758 8.99012C17.9576 8.94493 18.3662 9.1266 18.1391 10.2872C18.0603 10.6895 18 11 18 11C17.8809 11.7881 17.3781 12 16.6289 12H5.01465V14H15.0576C16.7202 14.0002 18.0684 15.3433 18.0684 17C18.0684 18.6567 16.7202 19.9998 15.0576 20C13.3948 20 12.0469 18.6569 12.0469 17C12.0469 16.6494 12.1068 16.3128 12.2178 16H6.85059C6.9615 16.3127 7.02148 16.6494 7.02148 17C7.02148 18.6569 5.67352 20 4.01074 20C2.34796 20 1 18.6569 1 17C1 15.6939 1.83765 14.5828 3.00684 14.1709V2H2.00391C1.44965 2 1 1.55228 1 1C1 0.447715 1.44965 0 2.00391 0H3.50879ZM4.01074 16C3.45648 16 3.00684 16.4477 3.00684 17C3.00684 17.5523 3.45648 18 4.01074 18C4.565 18 5.01465 17.5523 5.01465 17C5.01465 16.4477 4.565 16 4.01074 16ZM15.0576 16C14.5034 16 14.0537 16.4477 14.0537 17C14.0537 17.5523 14.5034 18 15.0576 18C15.6117 17.9998 16.0605 17.5522 16.0605 17C16.0605 16.4478 15.6117 16.0002 15.0576 16Z"
    />
  </svg>
);

const CartCheck = <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className='Polaris-Icon__Svg'>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M1 1C1 0.447715 1.44772 0 2 0H3.5C4.32843 0 5 0.671572 5 1.5V10H16.1327L17.0101 3.85858C17.0882 3.31184 17.5947 2.93195 18.1414 3.01005C18.6882 3.08816 19.0681 3.59469 18.99 4.14142L18.0513 10.7121C17.9457 11.4511 17.3128 12 16.5664 12H5V14H15C16.6569 14 18 15.3431 18 17C18 18.6569 16.6569 20 15 20C13.3431 20 12 18.6569 12 17C12 16.6494 12.0602 16.3128 12.1707 16H6.82929C6.93985 16.3128 7 16.6494 7 17C7 18.6569 5.65685 20 4 20C2.34315 20 1 18.6569 1 17C1 15.6938 1.83481 14.5825 3 14.1707V2H2C1.44772 2 1 1.55228 1 1ZM14 17C14 16.4477 14.4477 16 15 16C15.5523 16 16 16.4477 16 17C16 17.5523 15.5523 18 15 18C14.4477 18 14 17.5523 14 17ZM3 17C3 16.4477 3.44772 16 4 16C4.55228 16 5 16.4477 5 17C5 17.5523 4.55228 18 4 18C3.44772 18 3 17.5523 3 17Z" />
  <path d="M13.7928 1.29285L10.4998 4.58585L9.20685 3.29285C9.114 3.2 9.00378 3.12636 8.88247 3.07611C8.76117 3.02586 8.63115 3 8.49985 3C8.36855 3 8.23853 3.02586 8.11722 3.07611C7.99592 3.12636 7.88569 3.2 7.79285 3.29285C7.70001 3.38569 7.62636 3.49592 7.57611 3.61722C7.52586 3.73853 7.5 3.86855 7.5 3.99985C7.5 4.13115 7.52586 4.26117 7.57611 4.38247C7.62636 4.50378 7.70001 4.61401 7.79285 4.70685L9.79285 6.70685C9.8855 6.80004 9.99566 6.87399 10.117 6.92445C10.2383 6.97491 10.3684 7.00089 10.4998 7.00089C10.6313 7.00089 10.7614 6.97491 10.8827 6.92445C11.004 6.87399 11.1142 6.80004 11.2068 6.70685L15.2069 2.70685C15.2997 2.614 15.3733 2.50378 15.4236 2.38247C15.4738 2.26117 15.4997 2.13115 15.4997 1.99985C15.4997 1.86855 15.4738 1.73853 15.4236 1.61722C15.3733 1.49592 15.2997 1.38569 15.2069 1.29285C15.114 1.2 15.0038 1.12636 14.8825 1.07611C14.7612 1.02586 14.6312 1 14.4998 1C14.3685 1 14.2385 1.02586 14.1172 1.07611C13.9959 1.12636 13.8857 1.2 13.7928 1.29285Z" />
</svg>

// List of page type for recommendation widget
export const RECOMMENDATION_WIDGET_PAGE_TYPES = {
  'home-page': {
    name: 'AdminHTML.Recommendation.Constants.pageType_Homepage_Label',
    icon: HomeMajor
  },
  'product-page': {
    name: 'AdminHTML.Recommendation.Constants.pageType_ProductPage_Label',
    icon: ProductsMajor
  },
  'collection-page': {
    name: 'AdminHTML.Recommendation.Constants.pageType_CollectionPage_Label',
    icon: CollectionsMajor
  },
  'cart-page': {
    name: 'AdminHTML.Recommendation.Constants.pageType_CartPage_Label',
    icon: CheckoutMajor
  },
  [CART_DRAWER]: {
    name: 'AdminHTML.Recommendation.Constants.pageType_CartDrawer_Label',
    icon: CheckOutPlus,
    isCustomizedIcon: true
  },
  'checkout-page': {
    name: 'AdminHTML.Recommendation.Constants.pageType_CheckoutPage_Label',
    icon: CartCheck,
    isCustomizedIcon: true
  },
};

// List of recommendation type for recommendation widget
export const RECOMMENDATION_WIDGET_RECOMMENDATION_TYPES = {
  bestsellers: {
    value: 'bestsellers',
    name: 'AdminHTML.Recommendation.Constants.recommendationType_Bestsellers_Label',
    description: 'AdminHTML.Recommendation.Constants.recommendationType_Bestsellers_Description',
    hasSettings: true
  },
  'newest-arrivals': {
    value: 'newest-arrivals',
    name: 'AdminHTML.Recommendation.Constants.recommendationType_NewestArrivals_Label',
    description: 'AdminHTML.Recommendation.Constants.recommendationType_NewestArrivals_Description',
    hasSettings: false
  },
  'frequently-bought-together': {
    value: 'frequently-bought-together',
    name: 'AdminHTML.Recommendation.Constants.recommendationType_FrequentlyBoughtTogether_Label',
    description:
      'AdminHTML.Recommendation.Constants.recommendationType_FrequentlyBoughtTogether_Description',
    hasSettings: true,
    isAIPowered: true
  },
  'trending-products': {
    value: 'trending-products',
    name: 'AdminHTML.Recommendation.Constants.recommendationType_TrendingProducts_Label',
    description:
      'AdminHTML.Recommendation.Constants.recommendationType_TrendingProducts_Description',
    hasSettings: true
  },
  'hand-picked-products': {
    value: 'hand-picked-products',
    name: 'AdminHTML.Recommendation.Constants.recommendationType_HandPickedProducts_Label',
    description:
      'AdminHTML.Recommendation.Constants.recommendationType_HandPickedProducts_Description',
    hasSettings: true
  },
  'recently-viewed': {
    value: 'recently-viewed',
    name: 'AdminHTML.Recommendation.Constants.recommendationType_RecentlyViewed_Label',
    description: 'AdminHTML.Recommendation.Constants.recommendationType_RecentlyViewed_Description',
    hasSettings: false
  },
  'most-viewed': {
    value: 'most-viewed',
    name: 'AdminHTML.Recommendation.Constants.recommendationType_MostViewed_Label',
    description: 'AdminHTML.Recommendation.Constants.recommendationType_MostViewed_Description',
    hasSettings: false
  },
  'related-items': {
    value: 'related-items',
    name: 'AdminHTML.Recommendation.Constants.recommendationType_RelatedItems_Label',
    description: 'AdminHTML.Recommendation.Constants.recommendationType_RelatedItems_Description',
    hasSettings: true,
    isAIPowered: true
  },
  'recently-purchased': {
    value: 'recently-purchased',
    name: 'AdminHTML.Recommendation.Constants.recommendationType_RecentlyPurchased_Label',
    description:
      'AdminHTML.Recommendation.Constants.recommendationType_RecentlyPurchased_Description',
    hasSettings: false
  },
  'personalized-recommendation': {
    value: PERSONALIZED_RECOMMENDATION,
    name: 'AdminHTML.Recommendation.Constants.recommendationType_Personalized_Label',
    defaultName: 'AdminHTML.Recommendation.Constants.recommendationType_Personalized_DefaultName',
    description: 'AdminHTML.Recommendation.Constants.recommendationType_Personalized_Description',
    hasSettings: true,
    isAIPowered: true
  }
};
// List of recommendation type per page type for recommendation widget
export const RECOMMENDATION_WIDGET_RECOMMENDATION_TYPES_WITH_PAGE_TYPES = {
  'home-page': {
    'personalized-recommendation': { mostUsed: true, premium: true },
    'recently-purchased': { mostUsed: true, premium: true },
    bestsellers: { mostUsed: true, premium: true },
    'newest-arrivals': { mostUsed: true, premium: true },
    'trending-products': { mostUsed: true, premium: true },
    'hand-picked-products': { mostUsed: true },
    'recently-viewed': { mostUsed: false, premium: true },
    'most-viewed': { mostUsed: false, premium: true }
  },
  'product-page': {
    'frequently-bought-together': { mostUsed: true, premium: true },
    'related-items': { mostUsed: true, premium: true },
    'personalized-recommendation': { mostUsed: true, premium: true },
    'recently-purchased': { mostUsed: true, premium: true },
    'most-viewed': { mostUsed: true, premium: true },
    'hand-picked-products': { mostUsed: true },
    'recently-viewed': { mostUsed: true, premium: true },
    bestsellers: { mostUsed: false, premium: true },
    'newest-arrivals': { mostUsed: false, premium: true },
    'trending-products': { mostUsed: false, premium: true }
  },
  'collection-page': {
    'personalized-recommendation': { mostUsed: true, premium: true },
    'recently-purchased': { mostUsed: true, premium: true },
    bestsellers: { mostUsed: true, premium: true },
    'trending-products': { mostUsed: true, premium: true },
    'most-viewed': { mostUsed: true, premium: true },
    'hand-picked-products': { mostUsed: true },
    'recently-viewed': { mostUsed: false, premium: true },
    'newest-arrivals': { mostUsed: false, premium: true }
  },
  'cart-page': {
    'personalized-recommendation': { mostUsed: true, premium: true },
    'frequently-bought-together': { mostUsed: true, premium: true },
    'related-items': { mostUsed: true, premium: true },
    'recently-purchased': { mostUsed: true, premium: true },
    bestsellers: { mostUsed: true, premium: true },
    'trending-products': { mostUsed: true, premium: true },
    'hand-picked-products': { mostUsed: true },
    'recently-viewed': { mostUsed: true, premium: true },
    'most-viewed': { mostUsed: false, premium: true },
    'newest-arrivals': { mostUsed: false, premium: true }
  },
  'checkout-page': {
    'personalized-recommendation': { mostUsed: false, premium: true, comingSoon: false },
    'frequently-bought-together': { mostUsed: false, premium: true },
    'related-items': { mostUsed: false, premium: true },
    'recently-viewed': { mostUsed: false, premium: true, comingSoon: true },
    'hand-picked-products': { mostUsed: false, comingSoon: true }
  },
  [CART_DRAWER]: {
    'personalized-recommendation': { mostUsed: false, premium: true, comingSoon: false },
    'frequently-bought-together': { mostUsed: false, premium: true, comingSoon: true },
    'related-items': { mostUsed: false, premium: true, comingSoon: true },
    bestsellers: { mostUsed: false, premium: true, comingSoon: true },
    'recently-purchased': { mostUsed: false, premium: true, comingSoon: true },
    'recently-viewed': { mostUsed: false, premium: true, comingSoon: true },
    'trending-products': { mostUsed: false, premium: true, comingSoon: true },
    'hand-picked-products': { mostUsed: false, comingSoon: true },
    'most-viewed': { mostUsed: false, premium: true, comingSoon: true },
    'newest-arrivals': { mostUsed: false, premium: true, comingSoon: true },
  }
};

// List of recommendation type per page type for recommendation widget for freemium
export const RECOMMENDATION_WIDGET_RECOMMENDATION_TYPES_WITH_PAGE_TYPES_FOR_FREEMIUM = {
  'home-page': {
    'hand-picked-products': { mostUsed: true, enableDefault: true },
    'personalized-recommendation': { mostUsed: true, premium: true, enableDefault: false },
    'recently-purchased': { mostUsed: true, premium: true, enableDefault: false },
    bestsellers: { mostUsed: true, premium: true, enableDefault: true },
    'newest-arrivals': { mostUsed: true, premium: true, enableDefault: true },
    'trending-products': { mostUsed: true, premium: true, enableDefault: true },
    'recently-viewed': { mostUsed: false, premium: true, enableDefault: true },
    'most-viewed': { mostUsed: false, premium: true, enableDefault: true }
  },
  'product-page': {
    'hand-picked-products': { mostUsed: true, enableDefault: true },
    'personalized-recommendation': { mostUsed: true, premium: true, enableDefault: false },
    'frequently-bought-together': { mostUsed: true, premium: true, enableDefault: false },
    'related-items': { mostUsed: true, premium: true, enableDefault: false },
    'recently-purchased': { mostUsed: true, premium: true, enableDefault: false },
    'most-viewed': { mostUsed: true, premium: true, enableDefault: true },
    'recently-viewed': { mostUsed: true, premium: true, enableDefault: true },
    bestsellers: { mostUsed: false, premium: true, enableDefault: true },
    'newest-arrivals': { mostUsed: false, premium: true, enableDefault: true },
    'trending-products': { mostUsed: false, premium: true, enableDefault: true }
  },
  'collection-page': {
    'hand-picked-products': { mostUsed: true, enableDefault: true },
    'personalized-recommendation': { mostUsed: true, premium: true, enableDefault: false },
    'recently-purchased': { mostUsed: true, premium: true, enableDefault: false },
    bestsellers: { mostUsed: true, premium: true, enableDefault: true },
    'trending-products': { mostUsed: true, premium: true, enableDefault: true },
    'most-viewed': { mostUsed: true, premium: true, enableDefault: true },
    'recently-viewed': { mostUsed: false, premium: true, enableDefault: true },
    'newest-arrivals': { mostUsed: false, premium: true, enableDefault: true }
  },
  'cart-page': {
    'hand-picked-products': { mostUsed: true, enableDefault: true },
    'personalized-recommendation': { mostUsed: true, premium: true, enableDefault: false },
    'frequently-bought-together': { mostUsed: true, premium: true, enableDefault: false },
    'related-items': { mostUsed: true, premium: true, enableDefault: false },
    'recently-purchased': { mostUsed: true, premium: true, enableDefault: false },
    bestsellers: { mostUsed: true, premium: true, enableDefault: true },
    'trending-products': { mostUsed: true, premium: true, enableDefault: true },
    'recently-viewed': { mostUsed: true, premium: true, enableDefault: true },
    'most-viewed': { mostUsed: false, premium: true, enableDefault: true },
    'newest-arrivals': { mostUsed: false, premium: true, enableDefault: true }
  },
  'checkout-page': {
    'personalized-recommendation': { mostUsed: false, premium: true, comingSoon: false },
    'frequently-bought-together': { mostUsed: false, premium: true },
    'related-items': { mostUsed: false, premium: true },
    'recently-viewed': { mostUsed: false, premium: true, comingSoon: true },
    'hand-picked-products': { mostUsed: false, comingSoon: true }
  }
};

export const RECOMMENDATION_WIDGET_TRENDING_PRODUCTS_DATE_RANGE = [
  { value: '7', label: 'AdminHTML.Recommendation.Constants.dateRange_7' },
  { value: '6', label: 'AdminHTML.Recommendation.Constants.dateRange_6' },
  { value: '5', label: 'AdminHTML.Recommendation.Constants.dateRange_5' },
  { value: '4', label: 'AdminHTML.Recommendation.Constants.dateRange_4' },
  { value: '3', label: 'AdminHTML.Recommendation.Constants.dateRange_3' },
  { value: '2', label: 'AdminHTML.Recommendation.Constants.dateRange_2' },
  { value: '1', label: 'AdminHTML.Recommendation.Constants.dateRange_1' }
];

export const RECOMMENDATION_AI_BASED_FBT_PRIMARY_OPTIONS = [
  { label: 'AdminHTML.Recommendation.WidgetItem.aiBased_PrimaryOption_FBT', value: 'FBT' }
];

export const RECOMMENDATION_AI_BASED_FBT_SECONDARY_OPTIONS = [
  {
    label: 'AdminHTML.Recommendation.Constants.recommendationType_Bestsellers_Label',
    value: 'bestsellers'
  },
  {
    label: 'AdminHTML.Recommendation.Constants.recommendationType_MostViewed_Label',
    value: 'most-viewed'
  },
  {
    label: 'AdminHTML.Recommendation.Constants.recommendationType_NewestArrivals_Label',
    value: 'newest-arrivals'
  },
  {
    label: 'AdminHTML.Recommendation.WidgetItem.aiBased_PrimaryOption_Related_Alternative',
    value: 'Alternative'
  },
  {
    label: 'AdminHTML.Recommendation.WidgetItem.aiBased_PrimaryOption_Related_Complementary',
    value: 'Complementary'
  },
  { label: 'AdminHTML.Recommendation.WidgetItem.aiBased_SecondaryOption_Notset', value: 'unset' }
];

export const RECOMMENDATION_AI_BASED_BESTSELLERS_OPTIONS = [
  {
    label: 'AdminHTML.Recommendation.Constants.recommendationType_Bestsellers_Label',
    value: 'bestsellers'
  }
];

export const RECOMMENDATION_AI_BASED_PERSONALIZED_PRIMARY_OPTIONS = [
  {
    label: 'AdminHTML.Recommendation.WidgetItem.aiBased_PrimaryOption_Personalized',
    value: PERSONALIZED_RECOMMENDATION
  }
];

export const RECOMMENDATION_AI_BASED_PERSONALIZED_SECONDARY_OPTIONS = [
  {
    label: 'AdminHTML.Recommendation.Constants.recommendationType_Bestsellers_Label',
    value: 'bestsellers'
  },
  {
    label: 'AdminHTML.Recommendation.Constants.recommendationType_MostViewed_Label',
    value: 'most-viewed'
  },
  {
    label: 'AdminHTML.Recommendation.Constants.recommendationType_NewestArrivals_Label',
    value: 'newest-arrivals'
  },
  {
    label: 'AdminHTML.Recommendation.WidgetItem.aiBased_PrimaryOption_Related_Alternative',
    value: 'Alternative'
  },
  {
    label: 'AdminHTML.Recommendation.WidgetItem.aiBased_PrimaryOption_Related_Complementary',
    value: 'Complementary'
  },
  {
    label: 'AdminHTML.Recommendation.Constants.recommendationType_FrequentlyBoughtTogether_Label',
    value: 'FBT'
  },
  { label: 'AdminHTML.Recommendation.WidgetItem.aiBased_SecondaryOption_Notset', value: 'unset' }
];

export const RECOMMENDATION_AI_BASED_RELATED_PRIMARY_OPTIONS = [
  {
    label: 'AdminHTML.Recommendation.WidgetItem.aiBased_PrimaryOption_Related_Alternative',
    value: 'alternative-products',
    helper: 'AdminHTML.Recommendation.WidgetItem.aiBased_PrimaryOption_Related_Alternative_Helper'
  },
  {
    label: 'AdminHTML.Recommendation.WidgetItem.aiBased_PrimaryOption_Related_Complementary',
    value: 'complementary-products',
    helper: 'AdminHTML.Recommendation.WidgetItem.aiBased_PrimaryOption_Related_Complementary_Helper'
  },
  {
    label: 'AdminHTML.Recommendation.WidgetItem.aiBased_PrimaryOption_Related_Both',
    value: 'both',
    helper: 'AdminHTML.Recommendation.WidgetItem.aiBased_PrimaryOption_Related_Both_Helper'
  }
];

export const RECOMMENDATION_AI_BASED_RELATED_ALTERNATIVE_SECONDARY_OPTIONS = [
  {
    label: 'AdminHTML.Recommendation.Constants.recommendationType_Bestsellers_Label',
    value: 'bestsellers'
  },
  {
    label: 'AdminHTML.Recommendation.Constants.recommendationType_MostViewed_Label',
    value: 'most-viewed'
  },
  {
    label: 'AdminHTML.Recommendation.Constants.recommendationType_NewestArrivals_Label',
    value: 'newest-arrivals'
  },
  {
    label: 'AdminHTML.Recommendation.WidgetItem.aiBased_PrimaryOption_Related_Complementary',
    value: 'Complementary'
  },
  { label: 'AdminHTML.Recommendation.WidgetItem.aiBased_SecondaryOption_Notset', value: 'unset' }
];

export const RECOMMENDATION_AI_BASED_RELATED_COMPLEMENTARY_SECONDARY_OPTIONS = [
  {
    label: 'AdminHTML.Recommendation.Constants.recommendationType_Bestsellers_Label',
    value: 'bestsellers'
  },
  {
    label: 'AdminHTML.Recommendation.Constants.recommendationType_MostViewed_Label',
    value: 'most-viewed'
  },
  {
    label: 'AdminHTML.Recommendation.Constants.recommendationType_NewestArrivals_Label',
    value: 'newest-arrivals'
  },
  {
    label: 'AdminHTML.Recommendation.WidgetItem.aiBased_PrimaryOption_Related_Alternative',
    value: 'Alternative'
  },
  { label: 'AdminHTML.Recommendation.WidgetItem.aiBased_SecondaryOption_Notset', value: 'unset' }
];

export const RECOMMENDATION_AI_BASED_RELATED_BOTH_SECONDARY_OPTIONS = [
  {
    label: 'AdminHTML.Recommendation.Constants.recommendationType_Bestsellers_Label',
    value: 'bestsellers'
  },
  {
    label: 'AdminHTML.Recommendation.Constants.recommendationType_MostViewed_Label',
    value: 'most-viewed'
  },
  {
    label: 'AdminHTML.Recommendation.Constants.recommendationType_NewestArrivals_Label',
    value: 'newest-arrivals'
  },
  {
    label: 'AdminHTML.Recommendation.WidgetItem.aiBased_PrimaryOption_Related_Alternative',
    value: 'Alternative'
  },
  { label: 'AdminHTML.Recommendation.WidgetItem.aiBased_SecondaryOption_Notset', value: 'unset' }
];

export const RECOMMENDATION_WIDGET_TRENDING_PRODUCTS_BASED_ON_TYPES = [
  { value: 'view-events', label: 'AdminHTML.Recommendation.Constants.trendingProductBasedOn_View' },
  {
    value: 'purchase-events',
    label: 'AdminHTML.Recommendation.Constants.trendingProductBasedOn_Purchase'
  }
];

export const RECOMMENDATION_WIDGET_AI_BASED_RECOMMENDATION_TYPES = [
  {
    value: 'complementary-products',
    label: 'AdminHTML.Recommendation.Constants.aIBasedRecommendation_Complementary',
    labelAddition: [
      {
        name: 't1',
        label: 'AdminHTML.Recommendation.Constants.aIBasedRecommendation_Complementary_t1',
        type: 'strong'
      },
      {
        name: 't2',
        label: 'AdminHTML.Recommendation.Constants.aIBasedRecommendation_Complementary_t2',
        type: 'strong'
      }
    ]
  },
  {
    value: 'alternative-products',
    label: 'AdminHTML.Recommendation.Constants.aIBasedRecommendation_Alternative',
    labelAddition: [
      {
        name: 't1',
        label: 'AdminHTML.Recommendation.Constants.aIBasedRecommendation_Alternative_t1',
        type: 'strong'
      },
      {
        name: 't2',
        label: 'AdminHTML.Recommendation.Constants.aIBasedRecommendation_Alternative_t2',
        type: 'strong'
      }
    ]
  },
  {
    value: 'both',
    label: 'AdminHTML.Recommendation.Constants.aIBasedRecommendation_Both',
    labelAddition: [
      {
        name: 't1',
        label: 'AdminHTML.Recommendation.Constants.aIBasedRecommendation_Both_t1',
        type: 'strong'
      }
    ]
  }
];

export const RECOMMENDATION_WIDGET_LIMIT_RULE_BASED_RECOMMENDATION = 4;

export const RECOMMENDATION_WIDGET_RULE_BASED_RECOMMENDATION_TYPES = {
  SAME_COLLECTION: 'sameCollection',
  SAME_PRODUCT_CATEGORY: 'sameProductCategory',
  SAME_PRODUCT_TYPE: 'sameProductType',
  SAME_VENDOR: 'sameVendor',
  SAME_TAGS: 'sameTags',
  SAME_METAFIELD_1: 'sameMetafield_1',
  SAME_METAFIELD_2: 'sameMetafield_2',
  SAME_METAFIELD_3: 'sameMetafield_3'
};
export const RECOMMENDATION_WIDGET_RULE_BASED_RECOMMENDATION_TYPES_LABEL = {
  sameCollection: 'AdminHTML.Recommendation.Constants.ruleBasedRecommendation_SameCollection',
  sameProductCategory:
    'AdminHTML.Recommendation.Constants.ruleBasedRecommendation_SameProductCategory',
  sameProductType: 'AdminHTML.Recommendation.Constants.ruleBasedRecommendation_SameProductType',
  sameVendor: 'AdminHTML.Recommendation.Constants.ruleBasedRecommendation_SameVendor',
  sameTags: 'AdminHTML.Recommendation.Constants.ruleBasedRecommendation_SameTags',
  sameMetafield_1: 'AdminHTML.Recommendation.Constants.ruleBasedRecommendation_SameMetafield_1',
  sameMetafield_2: 'AdminHTML.Recommendation.Constants.ruleBasedRecommendation_SameMetafield_2',
  sameMetafield_3: 'AdminHTML.Recommendation.Constants.ruleBasedRecommendation_SameMetafield_3'
};

export const RECOMMENDATION_WIDGET_RULE_BASED_RECOMMENDATION_TYPES_DEFAULT = [
  { type: 'sameCollection', status: false },
  { type: 'sameProductCategory', status: false },
  { type: 'sameProductType', status: false },
  { type: 'sameVendor', status: false },
  { type: 'sameTags', status: false },
  { type: 'sameMetafield_1', status: false },
  { type: 'sameMetafield_2', status: false },
  { type: 'sameMetafield_3', status: false }
];

export const RECOMMENDATION_WIDGET_LIMIT_RULE_GROUPS = {
  'product-page': 150,
  'home-page': 1,
  'collection-page': 150,
  'cart-page': 1,
  'checkout-page': 0
};
export const LIMIT_CONDITION_PRODUCTS_PER_RULE_BY_RECOMMENDATION_TYPE = {
  'hand-picked-products': 15,
  bestsellers: 15
};
export const LIMIT_CONSEQUENCE_PRODUCTS_PER_RULE_BY_RECOMMENDATION_TYPE = {
  'hand-picked-products': 15,
  bestsellers: 5
};
export const RECOMMENDATION_WIDGET_RULE_GROUP_PRODUCT_OPTIONS = [
  { value: 'product_id', label: 'AdminHTML.Recommendation.Constants.productOption01_Label' },
  { value: 'collection_id', label: 'AdminHTML.Recommendation.Constants.productOption02_Label' }
];
export const DESIGN_STYLE_SETTINGS = [
  {
    value: 'default',
    label: 'AdminHTML.Recommendation.VisualEditor.designStyleSettings_Option01'
  },
  {
    value: 'customization',
    label: 'AdminHTML.Recommendation.VisualEditor.designStyleSettings_Option02'
  }
];

export const TEXT_ALIGNMENT = [
  {
    value: 'left',
    label: 'AdminHTML.Recommendation.Constants.textAlignment01_Label'
  },
  {
    value: 'center',
    label: 'AdminHTML.Recommendation.Constants.textAlignment02_Label'
  }
];

export const TEXT_TRANSFORM = [
  {
    value: 'none',
    label: 'AdminHTML.Recommendation.Constants.textTransform01_Label'
  },
  {
    value: 'uppercase',
    label: 'AdminHTML.Recommendation.Constants.textTransform02_Label'
  },
  {
    value: 'capitalize',
    label: 'AdminHTML.Recommendation.Constants.textTransform03_Label'
  },
  {
    value: 'lowercase',
    label: 'AdminHTML.Recommendation.Constants.textTransform04_Label'
  }
];

export const FONT_STYLE = [
  {
    value: 'regular',
    label: 'AdminHTML.Recommendation.Constants.fontStyle01_Label'
  },
  {
    value: 'italic',
    label: 'AdminHTML.Recommendation.Constants.fontStyle02_Label'
  }
];

export const LAYOUT_DISPLAY = [
  {
    value: 'carousel',
    maxNumberProductInWidget: 30,
    defaultMaxNumberProductInWidget: 12,
    label: 'AdminHTML.Recommendation.Constants.layoutDisplayChoice01_Label'
  },
  {
    value: 'grid',
    maxNumberProductInWidget: 5,
    defaultMaxNumberProductInWidget: 2,
    label: 'AdminHTML.Recommendation.Constants.layoutDisplayChoice02_Label'
  },
  {
    value: 'bundle',
    maxNumberProductInWidget: 5,
    defaultMaxNumberProductInWidget: 2,
    label: 'AdminHTML.Recommendation.Constants.layoutDisplayChoice03_Label'
  }
];

export const BUNDLE_STYLE = [
  {
    value: 'style1',
    label: 'AdminHTML.Recommendation.Constants.bundleStyle01_Label'
  },
  {
    value: 'style2',
    label: 'AdminHTML.Recommendation.Constants.bundleStyle02_Label'
  }
];
export const MANUAL_RECOMMENDATION_TAB_TYPE = {
  SEARCH_RESULT: 'search-result',
  HAND_PICKED_PRODUCTS: 'hand-picked-products',
  FREQUENTLY_BOUGHT_TOGETHER: 'frequently-bought-together',
  RELATED_ITEMS: 'related-items'
};

export const MANUAL_RECOMMENDATION_TAB_ITEM = {
  [MANUAL_RECOMMENDATION_TAB_TYPE.SEARCH_RESULT]: {
    id: 'search-result',
    content: 'AdminHTML.Recommendation.ManualRecommendation.ManualType.tab1_Title',
    panelID: 'search-result'
  },
  [MANUAL_RECOMMENDATION_TAB_TYPE.HAND_PICKED_PRODUCTS]: {
    id: 'hand-picked-products',
    content: 'AdminHTML.Recommendation.ManualRecommendation.ManualType.tab2_Title',
    panelID: 'hand-picked-products'
  },
  [MANUAL_RECOMMENDATION_TAB_TYPE.FREQUENTLY_BOUGHT_TOGETHER]: {
    id: 'frequently-bought-together',
    content: 'AdminHTML.Recommendation.ManualRecommendation.ManualType.tab3_Title',
    panelID: 'frequently-bought-together'
  },
  [MANUAL_RECOMMENDATION_TAB_TYPE.RELATED_ITEMS]: {
    id: 'related-items',
    content: 'AdminHTML.Recommendation.ManualRecommendation.ManualType.tab4_Title',
    panelID: 'related-items'
  }
};

export const MANUAL_RECOMMENDATION_TABS = [
  MANUAL_RECOMMENDATION_TAB_ITEM[MANUAL_RECOMMENDATION_TAB_TYPE.HAND_PICKED_PRODUCTS],
  MANUAL_RECOMMENDATION_TAB_ITEM[MANUAL_RECOMMENDATION_TAB_TYPE.FREQUENTLY_BOUGHT_TOGETHER],
  MANUAL_RECOMMENDATION_TAB_ITEM[MANUAL_RECOMMENDATION_TAB_TYPE.RELATED_ITEMS]
];

export const SEARCH_RESULT_MANUAL_RECOMMENDATION_TAB = 0;
export const HAND_PICKED_PRODUCT_TAB = 0;
export const FREQUENTLY_BOUGHT_TOGETHER_TAB = 1;
export const RELATED_ITEMS_TAB = 2;
export const NUMBER_RECOMMENDATION_PER_PAGE = 10;
export const LIMIT_SHOW_RECOMMENDATION_PRODUCT = 8;

export const NUMBER_PRODUCT = 15;
export const NUMBER_PRODUCT_PER_PAGE = 20;

export const AIML_MODEL_STATUS_BANNER_CONTENT = {
  // all
  'FBT_DONE-COMPLEMENTARY_DONE-ALTERNATIVE_DONE-AIRELATED_DONE': {
    type: 'done',
    group: 'AIModelBannerDone'
  },
  // end
  // related type
  'COMPLEMENTARY_DONE-ALTERNATIVE_DONE-AIRELATED_DONE': {
    type: 'done',
    group: 'AIModelBannerDone'
  },
  'COMPLEMENTARY_DONE-ALTERNATIVE_NOT_ENOUGH-AIRELATED_NOT_ENOUGH': {
    type: 'notEnoughData',
    group: 'AIModelBannerNotEnoughData',
    content: 'alternative'
  },
  'COMPLEMENTARY_DONE-ALTERNATIVE_PROCESSING-AIRELATED_PROCESSING': {
    type: 'processing',
    group: 'AIModelBannerProcessing',
    content: 'alternative'
  },
  'COMPLEMENTARY_NOT_ENOUGH-ALTERNATIVE_NOT_ENOUGH-AIRELATED_NOT_ENOUGH': {
    type: 'notEnoughData',
    group: 'AIModelBannerNotEnoughData',
    content: 'all'
  },
  'COMPLEMENTARY_NOT_ENOUGH-ALTERNATIVE_DONE-AIRELATED_NOT_ENOUGH': {
    type: 'notEnoughData',
    group: 'AIModelBannerNotEnoughData',
    content: 'complementary'
  },
  'COMPLEMENTARY_NOT_ENOUGH-ALTERNATIVE_PROCESSING-AIRELATED_NOT_ENOUGH': {
    type: 'processing_notEnough',
    group: 'AIModelBannerProcessing_NotEnough',
    content: 'alternative'
  },
  'COMPLEMENTARY_PROCESSING-ALTERNATIVE_DONE-AIRELATED_PROCESSING': {
    type: 'processing',
    group: 'AIModelBannerProcessing',
    content: 'complementary'
  },
  'COMPLEMENTARY_PROCESSING-ALTERNATIVE_NOT_ENOUGH-AIRELATED_NOT_ENOUGH': {
    type: 'processing_notEnough',
    group: 'AIModelBannerProcessing_NotEnough',
    content: 'complementary'
  },
  'COMPLEMENTARY_PROCESSING-ALTERNATIVE_PROCESSING-AIRELATED_PROCESSING': {
    type: 'processing',
    group: 'AIModelBannerProcessing',
    content: 'all'
  },
  // end
  PROCESSING: {
    type: 'processing',
    group: 'AIModelBannerProcessing',
    content: 'all'
  }
};

export const AIML_QUERY_INTERVAL_MILIS = 3000;

export const RECOMMENDATION_WIDGET_STATUS = [
  {
    value: 'live',
    label: 'AdminHTML.Recommendation.Constants.status_Live',
    labelDisplay: 'AdminHTML.Recommendation.Constants.status_Live_Display'
  },
  {
    value: 'draft',
    label: 'AdminHTML.Recommendation.Constants.status_Draft',
    labelDisplay: 'AdminHTML.Recommendation.Constants.status_Draft_Display'
  },
  {
    value: 'archive',
    label: 'AdminHTML.Recommendation.Constants.status_Archive',
    labelDisplay: 'AdminHTML.Recommendation.Constants.status_Archive_Display'
  }
];

export const ACCENT_COLOR = '#003D2C';

// Product tour config for list rule page

export const CONFIG_RECOMMENDATION_WIDGETS_TOUR = (i18n: Object) => {
  return [
    {
      selector: '[data-tut="pfs_tour_widgets"]',
      content: () => (
        <div className="widgets-tour">
          <h2 className="heading-tour">
            {i18n.translate('AdminHTML.Recommendation.WidgetTour.widgetStep01_title')}
          </h2>
          <div style={{ backgroundColor: 'rgb(255 255 255)' }}>
            <Lottie options={defaultOptions(dateRangeGif)} width={400} height={200} />
          </div>
          <div className="content-tour">
            {i18n.translate('AdminHTML.Recommendation.WidgetTour.widgetStep01_content')}
          </div>
        </div>
      ),
      position: 'left',
      style: {
        backgroundColor: 'white',
        padding: 0,
        width: '400px',
        maxWidth: 'unset',
        color: 'black',
        borderRadius: '8px'
      }
    },
    {
      selector: '[data-tut="pfs_tour_actions"]',
      content: () => (
        <div className="widgets-tour">
          <h2 className="heading-tour">
            {i18n.translate('AdminHTML.Recommendation.WidgetTour.widgetStep02_title')}
          </h2>
          <div style={{ backgroundColor: '#F1F2F3' }}>
            <Lottie options={defaultOptions(dateRangeGif)} width={400} height={200} />
          </div>
          <div className="content-tour">
            {i18n.translate('AdminHTML.Recommendation.WidgetTour.widgetStep02_content', {
              t: (
                <strong variation="strong">
                  {i18n.translate('AdminHTML.Recommendation.WidgetTour.widgetStep02_content_t')}
                </strong>
              )
            })}
          </div>
        </div>
      ),
      position: 'left',
      style: {
        backgroundColor: 'white',
        padding: 0,
        width: '400px',
        maxWidth: 'unset',
        borderRadius: '8px',
        color: 'black'
      }
    }
  ];
};

export const TEST_MOVING_PRODUCT_DATA_SOURCE_STORES = [
  'boost-pfs-test-kaylee03.myshopify.com',
  'boost-pfs-test-kaylee04.myshopify.com',
  'bc-dev-v2-kaylee1.myshopify.com',
  'boost-pfs-test-kaylee01.myshopify.com',
  'bc-dev-v2-kaylee2.myshopify.com',
  'boost-pfs-test-tae-kaylee.myshopify.com',
  'boost-pfs-test-tae-recommend.myshopify.com',
  'boost-pfs-test-kaylee02.myshopify.com',
  'bc-dev-v2-kaylee3.myshopify.com',
  'bc-dev-v2-daisy01.myshopify.com'
];

export const TITLE_FONT_SIZE = [
  { value: 'x-small', label: 'Extra small' },
  { value: 'small', label: 'Small' },
  { value: 'medium', label: 'Default' },
  { value: 'large', label: 'Medium' },
  { value: 'x-large', label: 'Large' },
  { value: 'xx-large', label: 'Extra large' }
];
